import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const routingRule = yup.object().required();

export const RoutingRuleResolver = yupResolver(routingRule);
